import { getShellLogger } from '../common/logger'
import { getAvatarUrls } from '../services/avatar'
import type { UserProfileInfo } from '../services/identity/models'
import { getIdFromUserProfile } from '../services/identity/userProfile'

export const getAvatarData = async (me: UserProfileInfo | undefined) => {
  try {
    // if we fail for any reason, we should continue
    return await getAvatarUrls(getIdFromUserProfile(me) ?? '')
  } catch (error) {
    getShellLogger().error(error)
    return undefined
  }
}
